import AbstractGuestlistDetailsPageController from '../abstract-details-controller';

export default class GuestlistTemplatesPageController extends AbstractGuestlistDetailsPageController {

}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/guestlists/messages/templates-controller.js